import { useMemo } from "react";
import PropTypes from "prop-types";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Stack } from "@/components/ui/layout";
import { cn } from "@/lib/utils";

const FrameComponent10 = ({
  className = "",
  frameDivGap,
  selectTopic,
  selectTopicColor,
  selectTopic1,
  type,
  options,
  value,
  onChange
}) => {
  const fieldLabelsStyle = useMemo(() => {
    return {
      gap: frameDivGap,
    };
  }, [frameDivGap]);

  const selectTopicStyle = useMemo(() => {
    return {
      color: selectTopicColor,
    };
  }, [selectTopicColor]);

  return (
    <Stack spacing="sm" align="start" className={cn("self-stretch", className)} style={fieldLabelsStyle}>
      <Label className="text-xl font-semibold" style={selectTopicStyle}>
        {selectTopic}
      </Label>
      {type === "select" && (
        <Select value={value} onValueChange={(val) => onChange?.({ target: { value: val } })}>
          <SelectTrigger className="w-full h-[70px] text-xl">
            <SelectValue placeholder={selectTopic1 || "Select an option"} />
          </SelectTrigger>
          <SelectContent>
            {options?.map((option, index) => (
              <SelectItem key={index} value={option}>
                {option}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
      {type === "difficulty" && (
        <Select value={value} onValueChange={(val) => onChange?.({ target: { value: val } })}>
          <SelectTrigger className="w-full h-[70px] text-xl">
            <SelectValue placeholder={selectTopic1 || "Select Difficulty Level"} />
          </SelectTrigger>
          <SelectContent>
            {options?.map((option, index) => (
              <SelectItem key={index} value={option}>
                {option}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
      {type === "datetime" && (
        <Input
          type="datetime-local"
          value={value}
          onChange={onChange}
          className="w-full h-[70px] text-xl"
        />
      )}
    </Stack>
  );
};

FrameComponent10.propTypes = {
  className: PropTypes.string,
  selectTopic: PropTypes.string,
  selectTopic1: PropTypes.string,

  /** Style props */
  frameDivGap: PropTypes.string,
  selectTopicColor: PropTypes.string,

  /** New props */
  type: PropTypes.oneOf(["select", "datetime", "difficulty"]), // To decide the input type
  options: PropTypes.arrayOf(PropTypes.string), // For dropdown options
};

export default FrameComponent10;
